import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { DomainConfigurationComponent } from './domain-configuration/domain-configuration.component';
import { DomainDirectoryServiceSyncComponent } from './domain-directory-service-sync/domain-directory-service-sync.component';
import { DomainItemComponent } from './domain-item.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        DomainConfigurationComponent,
        DomainDirectoryServiceSyncComponent,
        DomainItemComponent
    ],
    entryComponents: [DomainItemComponent],
    exports: [DomainItemComponent]
})
export class DomainItemModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-item/domain-item.module.ts